export default [
  {
    path: "/nomina",
    name: "nomina",
    component: () => import(/* webpackChunkName: "nomina" */ "./index.vue"),
  },
  {
    path: "/nomina/expediente-empleado/:idPersona",
    name: "nomina-expediente-empleado",
    component: () =>
      import(
        /* webpackChunkName: "nomina" */ "./components/expedienteEmpleado.vue"
      ),
  },
  {
    path: "/nomina/expediente-visualizar-empleado/:idPersona",
    name: "nomina-expediente-visualizar-empleado",
    component: () =>
      import(
        /* webpackChunkName: "nomina" */ "./components/ExpedienteVerEmpleado.vue"
      ),
  },
  {
    path: "/nomina/expediente-empleado/:idPersona/historial-documentos",
    name: "nomina-historial-documentos",
    component: () =>
      import(
        /* webpackChunkName: "nomina" */ "./components/HistorialDocumentos.vue"
      ),
  },
  {
    path: "/nomina/ordenes-descuento/:idPersona/empleado-puesto/:idEmpleadoPuesto/persona/:idEmpleado",
    name: "nomina-ordenes-descuento",
    component: () =>
      import(
        /* webpackChunkName: "nomina" */ "./components/IndexOrdenDescuento.vue"
      ),
  },
  {
    path: "/nomina/registro-empleado",
    name: "registro-empleado",
    component: () => import(/* webpackChunkName: "nomina" */ "./FormularioRegistroEmpleado.vue")
  },
  {
    path: "/nomina/registro-personal-destacado",
    name: "registro-personal-destacado",
    component: () => import(/* webpackChunkName: "nomina" */ "./FormularioRegistroPersonalDestacado.vue"),
  },
  {
    path: "/nomina/registro-personal-eventual",
    name: "registro-personal-eventual",
    component: () => import(/* webpackChunkName: "nomina" */ "./FormularioRegistroPersonalEventual.vue"),
  },
  {
    path: "/nomina/historial-empleado/:id",
    name: "historial-acciones-movimiento-empleado",
    component: () => import(/* webpackChunkName: "nomina" */ "./HistorialAccionesMovimientoPersonal.vue")
  }
];
